// Fragment "punch (lot P)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    "blog.slugRequired": "Ajoutez un titre avant d'enregistrer.",
    "gift.issueBtn": "Émettre",
    "gift.transferableNote": "Une carte-cadeau est transférable : toute personne détenant le code peut l'utiliser. L'e-mail du destinataire indique seulement où le code est ENVOYÉ — ce n'est pas un verrou d'utilisation.",
    // crm-module C2.05-integration: the rest of `auto.trigger.*`/`auto.action.*` was
    // correctly deleted with AutomationAdmin.jsx (decision 8, its only reader) — this
    // ONE key survives because modules/automation/schemas.py's AVAILABLE_TRIGGERS
    // deliberately keeps the raw `booking.completed` bus-event id registered (its own
    // comment: "kept... for the product census"), and test_reviews_event_census.py
    // pins a real, translated (not copy-pasted) label for it in all three locales.
    "auto.trigger.booking.completed": "Rendez-vous terminé",
  },
  en: {
    "blog.slugRequired": "Add a title before saving.",
    "gift.issueBtn": "Issue",
    "gift.transferableNote": "A gift card is transferable: anyone holding the code can redeem it. The recipient email only tells us where the code is SENT — it is not a redemption lock.",
    "auto.trigger.booking.completed": "Appointment completed",
  },
  es: {
    "blog.slugRequired": "Añade un título antes de guardar.",
    "gift.issueBtn": "Emitir",
    "gift.transferableNote": "Una tarjeta regalo es transferible: cualquier persona que tenga el código puede usarla. El correo del destinatario solo indica a dónde se ENVÍA el código — no es un bloqueo de uso.",
    "auto.trigger.booking.completed": "Cita finalizada",
  },
};
